/**
 * Utility functions for any storefront wizard region
 * TO-DO: refactor StorefrontWizardRegion and possibly CentralizedWizardRegion to make use of this utils file
 */

import * as React from "react";
import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "src/components/flexFramework/domain/BlossomComponentFactory";

/**
 *
 * @param flexModules Array of flex modules coming from the flex manager
 * Returns all modules corresponding to a wizard LOB form
 */
export const getWizardLOBFlexComponents = (flexModules: FlexComponent[]): FlexComponent[] => {
  return flexModules.filter((module: FlexComponent) => {
    return module && module.id && module.id.includes("wizard") && module.name !== "wizard-thirdPartyPackage-pwa";
  });
};

/**
 *
 * @param children Array of react components output by BlossomComponent
 * Returns all react components corresponding to a wizard LOB form
 */
export const getWizardLOBFormChildren = (children: React.ReactElement[]): React.ReactElement[] => {
  return children.filter((child) => {
    const { key } = child;

    return key && key.toString().includes("wizard");
  });
};

/**
 *
 * @param children Array of react components output by BlossomComponent
 * Returns all react components that do not correspond to a wizard LOB form
 * Does not categorize react components further
 */
export const getNonWizardFormChildren = (children: React.ReactElement[]): React.ReactElement[] => {
  return children
    .filter((child) => {
      const { key } = child;

      return key && !key.toString().includes("wizard");
    })
    .map((child) => {
      const { key } = child;

      const childComponent = BlossomComponentFactory.get(child.props as BlossomComponentFactoryProps);
      const childComponentModel = childComponent?.getModel() as any;
      if (childComponentModel && childComponentModel.horizontalCenter === false) {
        return (
          <div key={`parent-${key}`} className="prevent-justify-center">
            {child}
          </div>
        );
      }

      return <div key={`parent-${key}`}>{child}</div>;
    });
};

/**
 * Function part of test 33946; will be extracted into package after early signal
 */
export const emitUserInteractionDomainEvent = () => {
  const payload = {
    schemaName: "UserInteraction",
    schemaVersion: 1,
    payload: {
      event: {
        event_type: "Experience Usable",
        event_category: "Landing",
        event_name: "Home Usable",
        page_name: "Home",
      },
      timestamps: {
        sent_at: Date.now(),
        sent_at_timezone_offset_minutes: new Date().getTimezoneOffset(),
      },
    },
  };

  if (window?.location) {
    payload.payload["request"] = payload.payload["request"] || {};
    payload.payload["request"]["request_url"] = window.location.href;
  }

  if (document) {
    payload.payload["request"] = payload.payload["request"] || {};
    payload.payload["request"]["referrer_url"] = document.referrer;
  }

  const payloadString = JSON.stringify(payload);
  const httpRequest = new XMLHttpRequest();

  httpRequest.open("POST", "/uide/v1/collect", true);
  httpRequest.setRequestHeader("Content-type", "application/json");
  httpRequest.send(payloadString);
};
